// This is the implementation recommended by MDN for Math.log2: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log2#Polyfill
if (!Math.log2) {
  Math.log2 = x => Math.log(x) * Math.LOG2E;
}
